import generateId from 'lib/generateId';

export default function(authorId, message) {
  return {
    role: message.role,
    authorId,
    name: `Web User ${authorId}`,
    _id: generateId(),
    type: message.type,
    received: message.received,
    metadata: message.metadata,
    text: message.text,
    source: { type: 'web', id: '45d89dd8db3e4de29aead98423e9cf2e', integrationId: '5c6218bf90bcad0022f820ec' },
  };
}
